(function() {
    var forEach = Array.prototype.forEach;

    // Disable context menu on images
    forEach.call(document.querySelectorAll('.site-content img'), function(image) {
        image.addEventListener('contextmenu', function(e) {
            if (e.preventDefault) e.preventDefault();
            return false;
        });
    });

    // Fill in location and referrer hidden fields for the subscription form
    function fillInput(inputClass, value) {
        forEach.call(document.querySelectorAll('input.'+inputClass), function (el) {
            el.value = el.value || value;
        });
    };
    fillInput('location', window.location.href);
    fillInput('referrer', document.referrer);
})();

/*
  * reframe.js - Reframe.js: responsive iframes for embedded content
  * @version v2.2.5
  * @link https://github.com/dollarshaveclub/reframe.js#readme
  * @author Jeff Wainwright <jjwainwright2@gmail.com> (http://jeffry.in)
  * @license MIT
*/
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.reframe=t()}(this,function(){"use strict";function e(e,t){var i="string"==typeof e?document.querySelectorAll(e):e,n=t||"js-reframe";"length"in i||(i=[i]);for(var o=0;o<i.length;o+=1){var r=i[o];if(!(-1!==r.className.split(" ").indexOf(n))){var d=r.getAttribute("height"),f=r.getAttribute("width");if(!(f.indexOf("%")>-1||r.style.width.indexOf("%")>-1)){var a=(d||r.offsetHeight)/(f||r.offsetWidth)*100,s=document.createElement("div");s.className=n;var l=s.style;l.position="relative",l.width="100%",l.paddingTop=a+"%";var p=r.style;p.position="absolute",p.width="100%",p.height="100%",p.left="0",p.top="0",r.parentNode.insertBefore(s,r),r.parentNode.removeChild(r),s.appendChild(r)}}}}return e});

"use strict";

(function() {
    var forEach = Array.prototype.forEach;

    // Fix gallery images aspect ratio
    forEach.call(document.querySelectorAll('.kg-gallery-image img'), function (image) {
        var container = image.closest('.kg-gallery-image');
        var width = image.attributes.width.value;
        var height = image.attributes.height.value;
        var ratio = width / height;
        container.style.flex = ratio + ' 1 0%';
    });

    // Add missing alt text to images
    forEach.call(document.querySelectorAll('img.kg-image'), function (image) {
        if (!image.alt) {
            image.alt = "Photo by Olena (Aliona) Kuznetsova";
        }
    });

    // Make videos responsive
    var selectors = [
        'iframe[src*="player.vimeo.com"]',
        'iframe[src*="youtube.com"]',
        'iframe[src*="youtube-nocookie.com"]',
        'iframe[src*="kickstarter.com"][src*="video.html"]',
        'object',
        'embed'
    ];

    reframe(selectors.map(function(s) { return '.post-full-content ' + s; }).join(','));
})();
